import { Route, Switch, useRouteMatch } from "react-router";
import { formInfo } from "./form-info";

const Forms = () => {
    let { path } = useRouteMatch();

    return (
        <div id="forms">
            <Switch>
                {formInfo.map((form, i) => (
                    <Route key={i} path={path + form.path}>
                        {<form.component bucket={form.bucket} formTitle={form.formTitle} formType={form.formType} />}
                    </Route>
                ))}
            </Switch>
        </div>
    );
};

export default Forms;
